import { render, staticRenderFns } from "./FinancialSponsorAddress.vue?vue&type=template&id=d2dc31f4&scoped=true&"
import script from "./FinancialSponsorAddress.vue?vue&type=script&lang=ts&"
export * from "./FinancialSponsorAddress.vue?vue&type=script&lang=ts&"
import style0 from "./FinancialSponsorAddress.vue?vue&type=style&index=0&id=d2dc31f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dc31f4",
  null
  
)

export default component.exports